<template>
  <div class="drawer">
    <el-drawer
      size="1000px"
      title="押金明细"
      :visible.sync="drawerStatus"
      @close="close"
    >
      <div class="drawerContent">
        <div style="height: 100%; overflow: auto">
          <el-table
            class="table"
            :data="discountList"
            style="width: 100%; padding: 0"
          >
            <el-table-column
              label="优惠券名称"
              width="140"
              column-key="table4_1"
            >
              <template slot-scope="scope">
                {{ scope.row.coupon_name }}
              </template>
            </el-table-column>
            <el-table-column label="面额" width="180">
              <template slot-scope="scope">
                <span>{{ scope.row.money_reduce }}</span>
              </template>
            </el-table-column>
            <el-table-column label="满减规格" column-key="table4_2" width="90">
              <template slot-scope="scope">
                满 {{ scope.row.money_top }} 减{{ scope.row.money_reduce }}
              </template>
            </el-table-column>
            <el-table-column
              label="优惠券编码"
              column-key="table4_2"
              width="90"
            >
              <template slot-scope="scope">
                {{ scope.row._no }}
              </template>
            </el-table-column>
            <el-table-column
              label="优惠券类型"
              width="120"
              column-key="table4_1"
            >
              <template slot-scope="scope">
                <span
                  >{{ $public.getDiscountType(scope.row.apply_range.order_type) }}券</span
                >
              </template>
            </el-table-column>
            <el-table-column label="领取时间" width="90" column-key="table4_1">
              <template slot-scope="scope">
                <span>{{
                  $public.FTime(scope.row.receive_time, "YYYY-MM-DD")
                }}</span>
              </template>
            </el-table-column>
            <el-table-column label="有效期" width="170">
              <template slot-scope="scope">
                {{ $public.FTime(scope.row.use_start_time, "YYYY-MM-DD") }} --
                {{ $public.FTime(scope.row.use_end_time, "YYYY-MM-DD") }}
              </template>
            </el-table-column>
            <el-table-column label="使用门店" width="100" column-key="table4_1">
              <template slot-scope="scope">
                <span>{{ scope.row.use_shop }}</span>
              </template>
            </el-table-column>
            <el-table-column label="使用时间" width="90" column-key="table4_1">
              <template slot-scope="scope">
                {{ $public.FTime(scope.row.use_time, "YYYY-MM-DD") }}
              </template>
            </el-table-column>
            <el-table-column prop="remark" label="备注" width="100">
              <template slot-scope="scope">
                {{ scope.row.remark }}
              </template>
            </el-table-column>
          </el-table>
          <div style="padding: 10px">
            <page
              :page="page.page"
              :total="page.total"
              @change="changePage"
            ></page>
          </div>
        </div>
        <div class="btnBox">
          <div class="btnItem" @click="close">取消</div>
          <div class="btnItem submit" @click="submit">确定</div>
        </div>
      </div>
    </el-drawer>
  </div>
</template>

<script>
import page from "../../../../components/page.vue";
export default {
  components: { page },
  data() {
    return {
      drawerStatus: false,

      page: {
        page: 1,
        pageSize: 10,
        total: 0,
      },
      discountList: [],
    };
  },
  computed: {
    userInfo() {
      return this.$store.state.yiliaoxin.userInfo;
    },
    curPetInfo() {
      let obj = this.$store.getters["yiliaoxin/curPetInfo"];
      return obj;
    },
  },
  mounted() {
    this.$nextTick(() => {
      this.drawerStatus = true;
    });
    this.getUserDiscountList();
  },
  methods: {
    close() {
      this.$emit("submit", { type: "close" });
    },
    // 保存基本信息
    submit() {
      this.$emit("submit", { type: "success" });
    },
    changePage(num) {
      this.page.page = num;
      this.getUserDiscountList();
    },
    getUserDiscountList() {
      let params = {
        memberId: this.userInfo._id, // 用户id
        pageIndex: this.page.page,
        pageSize: this.page.pageSize,
      };
      let loading = this.$loading();
      this.$http.get("/api/Member/MemberCoupon", params).then((res) => {
        loading.close();
        if (res.code == 0) {
          this.discountList = res.data.data;
          this.page.total = res.data.count;
        }
      });
    },
  },
};
</script>

<style scoped lang="scss">
.drawer {
  ::v-deep .el-drawer {
    .el-drawer__header {
      margin-bottom: 10px;
    }
    .el-drawer__body {
      height: calc(100% - 54px);
    }
  }
}
.drawerContent {
  height: 100%;
  padding-bottom: 40px;
  box-sizing: border-box;
  .btnBox {
    width: 100%;
    font-size: 14px;
    color: #fff;
    line-height: 40px;
    display: flex;
    position: absolute;
    bottom: 0;
    z-index: 10;
    .btnItem {
      text-align: center;
      width: 100%;
      background-color: #d6d6d6;
      cursor: pointer;
      &.submit {
        background-color: $mainColor;
      }
    }
  }
}
</style>
